import { Check } from "lucide-react";

export default function FeatureSection({ section, index }) {
  const isReversed = section.imageLeft;
  const bgClass = section.bgLight ? "bg-[#F9FAFB]" : "bg-white";

  return (
    <section
      id={section.id}
      data-testid={`feature-section-${section.id}`}
      className={`${bgClass} py-12 md:py-20`}
      aria-label={section.label}
    >
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
        <div
          className={`grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center ${
            isReversed ? "" : ""
          }`}
        >
          {/* Text column - always first on mobile */}
          <div className={`space-y-6 order-1 ${isReversed ? "lg:order-2" : "lg:order-1"}`}>
            <span
              className="text-xs font-bold uppercase tracking-widest text-[#D4A84B]"
              data-testid={`feature-label-${section.id}`}
            >
              {section.label}
            </span>

            <h2
              className="font-heading text-3xl md:text-4xl font-bold text-[#1A1A1A] leading-tight tracking-tight"
              data-testid={`feature-heading-${section.id}`}
            >
              {section.heading}
            </h2>

            <p className="text-[#6B7280] text-base leading-relaxed">
              {section.body}
            </p>

            <ul className="space-y-3">
              {section.bullets.map((bullet, i) => (
                <li
                  key={i}
                  className="flex items-start gap-3"
                  data-testid={`feature-bullet-${section.id}-${i}`}
                >
                  <span className="inline-flex items-center justify-center w-5 h-5 rounded-full bg-[#D8FFB8] shrink-0 mt-0.5">
                    <Check className="h-3 w-3 text-[#20611B]" />
                  </span>
                  <span className="text-sm text-[#1A1A1A]">{bullet}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Placeholder screenshot - device frame */}
          <div className={`order-2 ${isReversed ? "lg:order-1" : "lg:order-2"}`}>
            <div
              data-testid={`feature-placeholder-${section.id}`}
              className="bg-[#F4F5F7] border border-gray-300 rounded-xl shadow-md aspect-[4/3] flex items-center justify-center p-6 relative overflow-hidden"
              role="img"
              aria-label={section.placeholder}
            >
              {/* Top bar mimicking app chrome */}
              <div className="absolute top-0 left-0 right-0 h-6 bg-gray-200/80 flex items-center px-3 gap-1">
                <span className="w-2 h-2 rounded-full bg-gray-400" />
                <span className="w-2 h-2 rounded-full bg-gray-400" />
                <span className="w-2 h-2 rounded-full bg-gray-400" />
              </div>
              <p className="text-sm text-[#6B7280] text-center">{section.placeholder}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
